<template>

  <v-btn v-if="unhiddenHeaders.length > 0" icon>

    <v-icon icon="$settings" />
    <v-tooltip activator="parent" location="top" :text="$t('titles.columns')" />

    <v-menu activator="parent" :close-on-content-click="false">
      <v-list select-strategy="classic" density="compact" v-model:selected="model"> <!-- TODO: is density being honored? -->

        <!--
        TODO: This VListItem should have :disabled="!(header.toggleable ?? true)".
        However, that causes the VCheckboxBtn to be unchecked, even when the column is enabled. This makes the column
        permanently hidden. Presumably, this is a bug in Vuetify?
        For now, we'll just ignore the toggleable flag.
        -->
        <v-list-item v-for="header in unhiddenHeaders" :value="header.key">

          <template v-slot:prepend="{ isActive }">
            <v-list-item-action start>
              <v-checkbox-btn :model-value="isActive" />
            </v-list-item-action>
          </template>

          <v-list-item-title>{{ header.title }}</v-list-item-title>

        </v-list-item>

      </v-list>
    </v-menu>

  </v-btn>

</template>

<script setup lang="ts">

import { computed, onMounted, watch } from 'vue'
// @ts-ignore: Don't complain about missing typings
import Cookie from 'js-cookie'
import type { ColumnPickerHeader } from '../types/misc'

const model = defineModel<string[]>({default: []}) // pass an array of strings (column names) to this component's v-model prop

interface Props {
  headers?: ColumnPickerHeader[]
  remember?: string
}

const props = withDefaults(defineProps<Props>(), {
  headers: () => [],
})

const unhiddenHeaders = computed(() => {
  return props.headers.filter(header => !header?.hidden && !header?.hideFromPicker)
})

onMounted(() => {
  if (props.remember) {
    const rememberedJson = Cookie.get(`column_picker__${props.remember}`)
    if (rememberedJson) {
      const remembered = JSON.parse(rememberedJson)
      model.value.length = 0
      model.value.push(...remembered)
    }
  }
})

watch(model, (newValue) => {
  if (props.remember) {
    Cookie.set(`column_picker__${props.remember}`, JSON.stringify(newValue))
  }
})

</script>
